import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import { AppBar, CircularProgress, Tab, Tabs } from "@mui/material";
import Form from "../../components/form";
import AppContext from "../../container/context";
import serverHost from "../../services/serverHost";
import Videos from "./components/Videos";
import Musicas from "./components/Musicas";
import Pronuncias from "./components/Pronuncias";
import PlanoAulas from "./components/PlanoAulas";

export default function Unidade(props) {
  const [unidadeId] = useState(Number(props.match.params.id));
  const [ciclos, setCiclos] = useState([]);
  const { notification } = useContext(AppContext);
  const [unidade, setUnidade] = useState({});
  const [value, setValue] = useState(0);
  const history = props.history;
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregarComboCiclos();

    if (unidadeId > 0) {
      api.get("unidades/carregar", { id: unidadeId }).then((unidade) => {
        setUnidade(unidade);
        setCarregando(false);
      });
    }
  }, []);

  const carregarComboCiclos = () => {
    setCarregando(true);

    api
      .get("ciclos/listar")
      .then((comboCiclos) => {
        setCarregando(false);
        setCiclos(comboCiclos);
      })
      .catch((err) => {
        setCarregando(false);

        notification("error", "Erro ao listar os ciclos: " + err);
      });
  };

  const salvar = (formulario) => {
    setUnidade(formulario);
    
    const data = new FormData();

    data.append("cicloId", formulario.cicloId);
    data.append("numero", formulario.numero);
    data.append("sequencia", formulario.sequencia);
    data.append("titulo", formulario.titulo);
    data.append("descricao", formulario.descricao);
    if (formulario.inativacao && formulario.inativacao !== "0000-00-00")
      data.append("inativacao", formulario.inativacao);
    data.append("revisao", formulario.revisao ? 1 : 0);

    if (formulario.capa && formulario.capa[0]) {
      const extensaoCapa =
        formulario.capa[0].name.split(".")[
          formulario.capa[0].name.split(".").length - 1
        ];

      data.append("capa", formulario.capa[0]);
      data.append("extensaoCapa", extensaoCapa);
    } else {
      if (unidade.extensaoCapa)
        data.append("extensaoCapa", unidade.extensaoCapa);
    }

    if (unidadeId > 0) {
      data.append("id", unidadeId);
      api
        .post("unidades/editar", data)
        .then((res) => {
          notification("success", "Dados salvos!");
          return history.goBack();
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Número inválido");
            case 2:
              return notification("error", "Título inválido");
            case 3:
              return notification("error", "Ciclo inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .put("unidades/inserir", data)
        .then((res) => {
          notification("success", "Dados salvos!");
          return history.goBack();
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Número inválido");
            case 2:
              return notification("error", "Título inválido");
            case 3:
              return notification("error", "Ciclo inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const camposfiltros = () => {
    const campos = {
      cicloId: {
        label: "Ciclo",
        type: "select",
        emptyItem: true,
        space: 4,
        value: unidade.cicloId,
        array: {
          data: ciclos,
          value: "id",
          desc: "nome",
        },
      },
    };

    campos.numero = {
      label: "Número",
      type: "number",
      space: 2,
      value: unidade.numero,
    };

    campos.sequencia = {
      label: "Sequência",
      type: "number",
      space: 2,
      value: unidade.sequencia,
    };
    campos.titulo = {
      label: "Título",
      type: "text",
      space: 4,
      value: unidade.titulo,
    };

    campos.descricao = {
      label: "Descricao",
      type: "textarea",
      value: unidade.descricao,
    };

    campos.capa = {
      label: "Capa",
      type: "file",
      space: 6,
    };

    if (unidadeId > 0) {
      campos.player = {
        type: "component",
        value: (
          <img
            src={`${serverHost()}/${unidade.capa}`}
            alt="capa"
            className="media-object"
            width="100"
            height="100"
          />
        ),
        space: 6,
      };
    }

    campos.revisao = {
      label: "Unidade de revisão",
      type: "check",
      value: unidade.revisao ? unidade.revisao : false,
      space: 12,
    };
    campos.inativacao = {
      label: "Inativação",
      type: "date",
      value: unidade.inativacao,
      space: 12,
    };

    return campos;
  };

  const fFiltros = {
    title: "Unidade",
    form: camposfiltros(),
    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  return (
    <div>
      <AppBar
        sx={{
          marginTop: "15px",
        }}
        position="static"
        color="default"
      >
        {unidadeId > 0 && (
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="action tabs example"
            value={value}
          >
            <Tab label="Geral" onClick={() => setValue(0)} />
            <Tab label="Vídeos" number={0} onClick={() => setValue(1)} />
            <Tab label="Músicas" number={0} onClick={() => setValue(2)} />
            <Tab label="Pronúncias" number={0} onClick={() => setValue(3)} />
            <Tab
              label="Plano de aulas"
              number={0}
              onClick={() => setValue(4)}
            />
          </Tabs>
        )}
        {unidadeId === 0 && (
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="action tabs example"
            value={0}
          >
            <Tab label="Geral" />
          </Tabs>
        )}
      </AppBar>
      <br />
      {value === 0 && (
        <>{carregando ? <CircularProgress /> : <Form formData={fFiltros} />}</>
      )}
      {value === 1 && <Videos unidadeId={unidadeId} />}
      {value === 2 && <Musicas unidadeId={unidadeId} />}
      {value === 3 && <Pronuncias unidadeId={unidadeId} />}
      {value === 4 && <PlanoAulas unidadeId={unidadeId} history={history} />}
    </div>
  );
}
